import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCommissionsManagementList extends Layout {
    layoutheaderCommissionsManagement: LayoutHeader;
    sourceOffPayee: DataSource;
    tableCommissionsManagement: Table;
}
